import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';
import { SERVICES } from '@/data/site';

export default function ServicesSection() {
  return (
    <section id="offers" className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-28 bg-background-50">
      <div className="max-w-content mx-auto">
        <Reveal className="max-w-3xl">
          <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
            Our Services
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-tight text-foreground-950">
            The right people. The right connections. Your event.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700 max-w-2xl">
            Whether you&rsquo;re looking for one exceptional supplier, struggling to find something
            unusual, or bringing together a team for a special occasion, KOR38 makes finding the
            right people simpler.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((service, index) => (
            <Reveal
              key={service.id}
              as="article"
              delay={index * 90}
              className="flex flex-col h-full rounded-lg border border-background-200 bg-background-100 p-6 md:p-7"
            >
              <div className="flex items-center justify-between gap-4">
                <span className="w-12 h-12 rounded-md bg-secondary-900 flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-primary-400`} aria-hidden="true"></i>
                </span>
                <span className="font-label text-sm font-semibold text-primary-300">
                  {service.price}
                </span>
              </div>

              <h3 className="mt-6 font-heading text-xl md:text-2xl text-foreground-950">
                {service.name}
              </h3>
              <p className="mt-1 font-label text-xs uppercase tracking-[0.14em] text-accent-600">
                {service.subheading}
              </p>
              <p className="mt-4 text-base leading-relaxed text-foreground-700 flex-1">
                {service.summary}
              </p>

              <div className="mt-6 pt-6 border-t border-background-200">
                <Button to={service.path} variant="outline" size="md" className="w-full">
                  {service.cta}
                </Button>
                <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">{service.note}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}